import React from "react";
import ReactDOM from "react-dom";
import Routers from "./Routers";
import "assets/scss/material-kit-react.scss?v=1.10.0";

ReactDOM.render(<Routers />, document.getElementById("root"));
